export default __webpack_public_path__ + "static/Cambridge-Assessment-c19465a9d5762fe3dd61d271b4401a5d.jpeg";